import { useTranslation } from 'react-i18next';
import { Badge } from '@bliks-io/ui';

const EXPIRING_SOON_MS = 30 * 24 * 60 * 60 * 1000;

/** One definition of "expired" for the badge colour and the hide-expired filter. */
export function isTenantExpired(expiresAt: string | null): boolean {
  return !!expiresAt && Date.parse(expiresAt) < Date.now();
}

function expiryColorScheme(expiresAt: string): 'error' | 'warning' | 'neutral' {
  if (isTenantExpired(expiresAt)) return 'error';
  if (Date.parse(expiresAt) < Date.now() + EXPIRING_SOON_MS) return 'warning';
  return 'neutral';
}

export function TenantExpiryBadge({ expiresAt }: { expiresAt: string | null }) {
  const { t, i18n } = useTranslation();
  if (!expiresAt) {
    return <span className="text-muted-foreground">{t('tenantAdmin.expiresNever')}</span>;
  }
  // The edit dialog saves and shows the expiry as a UTC calendar day (dateInputToIso).
  const expiryDay = new Date(expiresAt).toLocaleDateString(i18n.language, { timeZone: 'UTC' });
  return <Badge colorScheme={expiryColorScheme(expiresAt)}>{expiryDay}</Badge>;
}
